export default __webpack_public_path__ + "static/media/HomerSimpson.2219a4bb.png";